"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCSRFToken = void 0;
const nanoid_1 = require("nanoid");
const constants_1 = require("./constants");
const cookies_1 = require("./cookies");
const generateNewToken = async (res) => {
    const csrfToken = (0, nanoid_1.nanoid)();
    const signedCookieValue = (0, cookies_1.sign)(csrfToken);
    (0, cookies_1.setCookie)(res, constants_1.COOKIE_NAME, await signedCookieValue);
    return csrfToken;
};
function withCSRFToken(getServerSideProps) {
    return async (context) => {
        const { req, res } = context;
        const token = req.cookies[constants_1.COOKIE_NAME];
        const extractedToken = token ? await (0, cookies_1.unSign)(token) : null;
        const csrfToken = extractedToken || (await generateNewToken(res));
        const serverProps = await getServerSideProps(context);
        let props = {};
        if ("props" in serverProps) {
            props = serverProps.props;
            if ("then" in props) {
                props = await props;
            }
        }
        return { ...serverProps, props: { ...props, csrfToken } };
    };
}
exports.withCSRFToken = withCSRFToken;
//# sourceMappingURL=withCSRFToken.js.map